import { Component } from "react";
import "../InterventionReportField.css";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import withAuth from "../../withAuth";
import PhotoFieldWithPreview from "../../Photos/PhotoFieldWithPreview";

class InterventionPhotoField extends Component {
	savePhoto(image) {
		let fieldValue = this.props.value;
		fieldValue.value_image = image;
		this.props.fieldValueChange(fieldValue);
	}

	render() {
		console.perfLog(getCurrentFunctionName());
		return (
			<div className="full_size control-margin-top">
				<PhotoFieldWithPreview
					disabled={this.props.inputProperties.disabled}
					onPhotoChange={this.savePhoto.bind(this)}
					value={this.props.value.value_image}
					id={this.props.model.code}
					label={this.props.model.name}
					inputProperties={this.props.inputProperties}
				/>
			</div>
		);
	}
}

export default withAuth(InterventionPhotoField);
